import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { assets, CancelRider, Checkbox, Input, makeRootStyles, PulseOpsFormat, RiderAlterationFormData, RiderAlterationService, SelectOption, SelectSearch, sharedStyle } from '@pulseops/common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import { Controller, UseFormReturn } from 'react-hook-form';
import moment from 'moment';
import { pipe } from 'fp-ts/function'
import * as O from 'fp-ts/Option'
import { MajorCombinedForm } from '@pulseops/submission';
interface MajorHealthcareDetailPanelProps {
  isOpen: boolean
  riderLAIndex: number
  riderSubIndex: number
  majorCombinedForm: UseFormReturn<MajorCombinedForm.MajorCombined>
  riderAlterationDetailData?: CancelRider.DetailCancelRiderInfo
  healthcareBenefitMasterData?: RiderAlterationService.HealthcareMasterDataResponse
  previousHealthcareBenefitList?: RiderAlterationFormData.HealthcareBenefitDetailInfo[]
  isDisabled: boolean
  onClose: () => void
  onConfirm?: () => void
  title?: string
  LABirthDate?: string
}

export const MajorHealthcareDetailPanelModal = ({
  isOpen,
  onClose,
  title = '',
  onConfirm,
  LABirthDate,
  riderLAIndex,
  riderSubIndex,
  majorCombinedForm,
  riderAlterationDetailData,
  healthcareBenefitMasterData,
  isDisabled,
  previousHealthcareBenefitList
}: MajorHealthcareDetailPanelProps) => {
  const { t } = useTranslation('');
  const tableClass = makeRootStyles();
  const minIPTerm = 5
  const healthcareBenefitArrayList = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList`) || []

  React.useEffect(() => {
    if (isOpen) {
    }
    return () => {
    }
  }, [isOpen])

  const IPOptionList = React.useMemo(() => {
    const optionList = pipe(
      O.fromNullable(healthcareBenefitMasterData?.body?.ipOptionList),
      O.fold(
        () => [],
        (optionList) => optionList.map((item) => ({ label: item.name, value: item.value }))
      )
    )
    return optionList
  }, [healthcareBenefitMasterData])

  const OPOptionList = React.useMemo(() => {
    const optionList = pipe(
      O.fromNullable(healthcareBenefitMasterData?.body?.opOptionList),
      O.fold(
        () => [],
        (optionList) => optionList.map((item) => ({ label: item.name, value: item.value }))
      )
    )
    return optionList
  }, [healthcareBenefitMasterData])

  const DEOptionList = React.useMemo(() => {
    const optionList = pipe(
      O.fromNullable(healthcareBenefitMasterData?.body?.deOptionList),
      O.fold(
        () => [],
        (optionList) => optionList.map((item) => ({ label: item.name, value: item.value }))
      )
    )
    return optionList
  }, [healthcareBenefitMasterData])

  const MAOptionList = React.useMemo(() => {
    const optionList = pipe(
      O.fromNullable(healthcareBenefitMasterData?.body?.maOptionList),
      O.fold(
        () => [],
        (optionList) => optionList.map((item) => ({ label: item.name, value: item.value }))
      )
    )
    return optionList
  }, [healthcareBenefitMasterData])


  const lifeAssuredAgeByYear = React.useMemo(() => {
    return LABirthDate ? moment(new Date()).diff(moment(LABirthDate, 'YYYYMMDD'), 'years') : 0
  }, [LABirthDate])

  const lifeAssuredAgeByDay = React.useMemo(() => {
    return LABirthDate ? moment(new Date()).diff(moment(LABirthDate, 'YYYYMMDD'), 'days') : 0
  }, [LABirthDate])

  const getSumAssuredOptionsByBenefitType = (benefitType: string) => {
    switch (benefitType) {
      case "IP":
        return IPOptionList
      case "OP":
        return OPOptionList
      case "DE":
        return DEOptionList
      case "MA":
        return MAOptionList
      default:
        return []
    }
  }

  const getCopayOptionsByBenefitType = (benefitType: string) => {
    switch (benefitType) {
      case "IP":
        return [{ label: "Y", value: "Y" }, { label: "N", value: "N" }]
      default:
        return [{ label: "Y", value: "Y" }]
    }
  }
  const getSumAssuredByType = (selectedIndex: number, benefitType: string, optionSASelectedItem: SelectOption | null) => {
    switch (benefitType) {
      case "IP": {
        const MAIndex = healthcareBenefitArrayList.findIndex((item) => item.benefit === "MA")
        majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex}.sumAssured`, optionSASelectedItem?.value || '')
        const MAOptionSAItem = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${MAIndex}.optionSA`)
        const MASumAssured = Number(optionSASelectedItem?.value || 0) * Number(MAOptionSAItem?.value || 0)
        //set MA Sum Assured
        majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${MAIndex}.sumAssured`, MASumAssured.toString())
        const OPOptionSA = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex + 1}.optionSA`)
        OPOptionSA && OPOptionSA.value && getSumAssuredByType(selectedIndex + 1, "OP", OPOptionSA)
        break
      }
      case "DE":
      case "OP": {
        if (optionSASelectedItem && optionSASelectedItem.value) {
          const IPSumAssured = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${0}.sumAssured`)
          const OPSumAssured = Number(IPSumAssured) * Number(optionSASelectedItem?.value || 0)
          //set OP Sum Assured
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex}.sumAssured`, OPSumAssured.toString())
          //set DE Sum Assured
          const DESelectedItem = optionSASelectedItem.value === '0.02'
            ? DEOptionList.find((item) => item.value === '0.01')
            : optionSASelectedItem.value === '0.04'
              ? DEOptionList.find((item) => item.value === '0.015')
              : DEOptionList.find((item) => item.value === '0.02')
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex + 1}.optionSA`, DESelectedItem || null)
          const DESumAssured = Number(IPSumAssured) * Number(DESelectedItem?.value || 0)
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex + 1}.sumAssured`, DESumAssured.toString())
        } else {
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex}.sumAssured`, '')
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex + 1}.optionSA`, null)
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${selectedIndex + 1}.sumAssured`, '')
        }
        break
      }
      case "MA": {
        const MAIndex = healthcareBenefitArrayList.findIndex((item) => item.benefit === "MA")
        const MAOptionSAItem = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${MAIndex}.optionSA`)
        const MASumAssured = Number(optionSASelectedItem?.value || 0) * Number(MAOptionSAItem?.value || 0)
        //set MA Sum Assured
        majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${MAIndex}.sumAssured`, MASumAssured.toString())
        break
      }
      default: {
        break
      }
    }
  }
  const onTickBenefitCheckboxEvent = (index: number, benefitType: string, checkedVal: boolean) => {
    switch (benefitType) {
      case "OP": {
        if (!checkedVal) {
          const DEIndex = healthcareBenefitArrayList.findIndex((x) => x.benefit === 'DE')
          const MAIndex = healthcareBenefitArrayList.findIndex((x) => x.benefit === 'MA')
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${DEIndex}.isCheckedBenefit`, false)
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${MAIndex}.isCheckedBenefit`, false)
        }
        break
      }
      case "DE": {
        if (checkedVal) {
          const OPIndex = healthcareBenefitArrayList.findIndex((x) => x.benefit === 'OP')
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${OPIndex}.isCheckedBenefit`, checkedVal)
        }
        break
      }
      case "MA": {
        if (checkedVal) {
          const OPIndex = healthcareBenefitArrayList.findIndex((x) => x.benefit === 'OP')
          getSumAssuredByType(index, benefitType, majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.0.optionSA`))
          majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${OPIndex}.isCheckedBenefit`, checkedVal)
        }
        break
      }
      default:
        break
    }
  }
  const hasDisabledBenefitCheckbox = (benefitType: string) => {
    switch (benefitType) {
      case "IP": {
        return true
      }
      case "DE":
      case "OP": {
        const isDisabledOPBenefit = lifeAssuredAgeByDay < 30 || lifeAssuredAgeByYear > 70
        return isDisabledOPBenefit
      }
      case "MA": {
        const isDisabledMABenefit = lifeAssuredAgeByYear < 18 || lifeAssuredAgeByYear > 45
        return isDisabledMABenefit
      }
      default:
        return false
    }
  }

  const hasDisabledOptionSA = (benefitType: string, index: number) => {
    switch (benefitType) {
      case "IP":
      case "OP": {
        const isCheckedBenefit = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.isCheckedBenefit`)
        return !isCheckedBenefit
      }
      case "DE":
      case "MA": {
        return true
      }
      default: {
        return false
      }
    }
  }

  const hasDisabledTerm = (benefitType: string) => {
    switch (benefitType) {
      case "IP": {
        return false
      }
      case "DE":
      case "OP":
      case "MA": {
        return true
      }
      default: {
        return false
      }
    }
  }
  const onChangeTermEvent = (selectedIndex: number, benefitType: string, termValue: string) => {
    switch (benefitType) {
      case "IP": {
        const OPIndex = healthcareBenefitArrayList.findIndex((x) => x.benefit === 'OP')
        const DEIndex = healthcareBenefitArrayList.findIndex((x) => x.benefit === 'DE')
        const MAIndex = healthcareBenefitArrayList.findIndex((x) => x.benefit === 'MA')
        const customedTermValue = termValue ? termValue : '0'
        const MATerm = Math.min(50 - lifeAssuredAgeByYear, parseInt(customedTermValue))
        majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${OPIndex}.term`, termValue)
        majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${DEIndex}.term`, termValue)
        majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${MAIndex}.term`, MATerm.toString())
        break
      }
      default:
    }
  }

  const maxIPTerm = React.useMemo(() => {
    const policyRemainingTerm = moment(riderAlterationDetailData?.riskCessDateOfPolicy).diff(moment(new Date()), 'years')
    const maxValue = Math.min(100 - lifeAssuredAgeByYear, policyRemainingTerm)
    return maxValue
  }, [lifeAssuredAgeByYear])

  const validateOptionSAByBenefitType = (benefitType: string, optionSAValue: SelectOption | null, index: number) => {
    switch (benefitType) {
      case "IP": {
        return (!optionSAValue || !optionSAValue.value) ? `${t('message:MS020001', { field: t('HealthcareDetailPopup:Option_SA') })}` : true
      }
      case "DE":
      case "OP": {
        const isCheckedBenefit = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.isCheckedBenefit`)
        return isCheckedBenefit && (!optionSAValue || !optionSAValue.value) ? `${t('message:MS020001', { field: t('HealthcareDetailPopup:Option_SA') })}` : true
      }

      default: {
        return true
      }
    }
  }

  const validateCopayByBenefitType = (benefitType: string, copayValue: SelectOption | null, index: number) => {
    switch (benefitType) {
      case "IP": {
        if (!copayValue || !copayValue.value) {
          return t('message:MS020001', { field: t('HealthcareDetailPopup:Co_pay') })
        } else if (copayValue && copayValue.value === 'N' && (lifeAssuredAgeByYear < 6 ||
          lifeAssuredAgeByYear >= 76
        )) {
          return t('message:MS020133')
        } else {
          return true
        }
      }
      default: {
        return true
      }
    }
  }

  const validateTermByBenefitType = (benefitType: string, termValue: string, index: number) => {
    switch (benefitType) {
      case "IP": {
        if (benefitType === 'IP' && Number(termValue || 0) < minIPTerm) {
          return t('message:MS020041')
        } else if (benefitType === 'IP' && Number(termValue || 0) > maxIPTerm) {
          return t('message:MS020137', { k: maxIPTerm })
        } else {
          return true
        }
      }
      default: {
        return true
      }
    }
  }

  const onConfirmEvent = async () => {
    const isValidHealthcareDetailForm = await majorCombinedForm.trigger(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList`)
    if (isValidHealthcareDetailForm) {
      onConfirm && onConfirm()
    }
  }

  const onCancelEvent = () => {
    majorCombinedForm.setValue(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList`, previousHealthcareBenefitList)
    onClose && onClose()
  }
  return (
    <Modal
      animationType="fade"
      onRequestClose={onCancelEvent}
      transparent
      visible={isOpen}
    >
      <View style={styles.modalContainer}>
        <View
          accessibilityRole="adjustable"
          accessibilityViewIsModal
          onStartShouldSetResponder={() => true}
          style={styles.modalContent}
        >
          <View style={styles.header}>
            <Text accessibilityRole="header" style={styles.title}>
              {title}
            </Text>
            <Pressable accessibilityLabel="Close" onPress={onClose} style={styles.iconButton}>
              <Text style={styles.iconText}>×</Text>
            </Pressable>
          </View>
          <View style={styles.content}>
            <TableContainer className={tableClass.container}>
              <Table className={tableClass.root}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: '5%' }}></TableCell>
                    <TableCell style={{ width: '15%' }}>{t('HealthcareDetailPopup:Benefit')}</TableCell>
                    <TableCell style={{ width: '35%' }}>{t('HealthcareDetailPopup:Option_SA')}</TableCell>
                    <TableCell style={{ width: '15%' }}>{t('HealthcareDetailPopup:Co_pay')}</TableCell>
                    <TableCell style={{ width: '30%' }}>{t('HealthcareDetailPopup:Term')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {healthcareBenefitArrayList && healthcareBenefitArrayList.length > 0 && healthcareBenefitArrayList.map((fieldItem, index) => {
                    const sumAssured = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.sumAssured`)
                    const isCheckedBenefit = majorCombinedForm.watch(`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.isCheckedBenefit`)
                    return (
                      <TableRow key={`HealthcareDetail_${index}`}>
                        <TableCell>
                          <Controller
                            control={majorCombinedForm.control}
                            name={`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.isCheckedBenefit`}
                            render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                              <Checkbox
                                onChange={(val) => {
                                  onChange(val)
                                  onTickBenefitCheckboxEvent(index, fieldItem.benefit || '', val)
                                }}
                                onBlur={onBlur}
                                value={value}
                                disabled={isDisabled || hasDisabledBenefitCheckbox(fieldItem.benefit || '')}
                                checkBoxStyle={styles.checkboxContainer}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <Text>{fieldItem.benefitName}</Text>
                        </TableCell>
                        <TableCell>
                          <Controller
                            control={majorCombinedForm.control}
                            name={`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.optionSA`}
                            rules={{
                              validate: (val) => {
                                return validateOptionSAByBenefitType(fieldItem.benefit || '', val, index)
                              }
                            }}
                            render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                              <SelectSearch
                                options={getSumAssuredOptionsByBenefitType(fieldItem.benefit || '')}
                                value={value}
                                onChange={(val) => {
                                  onChange(val)
                                  getSumAssuredByType(index, fieldItem.benefit || '', val)
                                }}
                                popupIcon={<assets.ArrowDownDropdownIcon />}
                                placeholder={t('common:Select')}
                                disabled={isDisabled || hasDisabledOptionSA(fieldItem.benefit || '', index)}
                                errorMessage={!value || !value.value ? error?.message : undefined}
                              />
                            )}
                          />
                          <View>
                            <Text>{`${t('HealthcareDetailPopup:SumAssured')}: ${PulseOpsFormat.thousandSepartor(Number(sumAssured || 0))}`}</Text>
                          </View>
                        </TableCell>
                        <TableCell>
                          <Controller
                            control={majorCombinedForm.control}
                            name={`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.copay`}
                            rules={{
                              validate: (val) => validateCopayByBenefitType(fieldItem.benefit || '', val, index)
                            }}
                            render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                              <SelectSearch
                                options={getCopayOptionsByBenefitType(fieldItem.benefit || '')}
                                value={value}
                                onChange={(val) => {
                                  onChange(val)
                                }}
                                popupIcon={<assets.ArrowDownDropdownIcon />}
                                placeholder={t('common:Select')}
                                disabled={isDisabled || fieldItem.isDisabledCopay || !isCheckedBenefit}
                                errorMessage={typeof validateCopayByBenefitType(fieldItem.benefit || '', value, index) === 'boolean' ? undefined : error?.message}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <Controller
                            control={majorCombinedForm.control}
                            name={`riderAlteration.newRiderLAList.${riderLAIndex}.newRiderList.${riderSubIndex}.healthcareBenefitDetailList.${index}.term`}
                            rules={{
                              validate: (val) => validateTermByBenefitType(fieldItem.benefit || '', val, index)
                            }}
                            render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                              <Input
                                value={value || ''}
                                onChange={(val) => {
                                  onChange(val)
                                  onChangeTermEvent(index, fieldItem.benefit || '', val)
                                }}
                                onBlur={onBlur}
                                inputType="number"
                                maxLength={3}
                                filled
                                disabled={isDisabled || !isCheckedBenefit || hasDisabledTerm(fieldItem.benefit || '')}
                                errorMessage={typeof validateTermByBenefitType(fieldItem.benefit || '', value, index) === 'boolean' ? undefined : error?.message}
                              />
                            )}
                          />
                        </TableCell>
                      </TableRow>
                    )
                  }
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </View>
          {!isDisabled && (
            <View style={styles.footer}>
              <Pressable onPress={onCancelEvent} style={[sharedStyle.button, styles.buttonContent]}>
                <Text style={sharedStyle.textButton}>{t('QC:Cancel')}</Text>
              </Pressable>
              <Pressable onPress={onConfirmEvent} style={[sharedStyle.button, sharedStyle.btnRed, styles.buttonContent]}>
                <Text style={sharedStyle.textButtonRed}>{t('common:Confirm')}</Text>
              </Pressable>
            </View>
          )}
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalContainer: {
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    flex: 1,
    justifyContent: 'center',
    padding: 16,
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: 8,
    maxWidth: 860,
    overflow: 'hidden',
    width: '100%',
  },
  header: {
    alignItems: 'center',
    borderBottomColor: '#e5e7eb',
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 16,
  },
  title: { fontSize: 20, fontWeight: '600' },
  iconButton: { padding: 4 },
  iconText: { fontSize: 26, lineHeight: 26 },
  content: { padding: 10 },
  footer: {
    borderTopColor: '#e5e7eb',
    borderTopWidth: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 12,
  },
  buttonContent: {
    marginVertical: 10,
  },
  checkboxContainer: {
    padding: 0,
    paddingLeft: 10,
    margin: 0
  }
});
